import React from "react";

import classnames from "classnames";

import { Div } from "Common/HTML";

import makeBem from "Utils/makeBem";

const bem = makeBem("LoadingBar");
interface LoadingBarProps {
  className?: string;
  ariaText?: string;
}

const LoadingBar = ({ className, ariaText = "Loading...", ...rest }: LoadingBarProps) => (
  <>
    <span className="sr-only">{ariaText}</span>
    <Div className={classnames(bem(), className)} aria-hidden="true" {...rest} />
  </>
);

export default LoadingBar;
